// @ts-nocheck - This file needs comprehensive TypeScript migration
import React, { useState } from 'react';
import { ChevronDown, Search } from 'lucide-react';
import ministryOfLaw from '../../assets/ministry_of_law.jpeg';

const FilterBar = ({ onLanguageChange }) => {
    const [filters, setFilters] = useState({
        courts: [],
        caseStatus: [],
        languages: 'English',
        year: new Date().getFullYear(),
        judges: [],
        keywords: '',
        caseTypes: []
    });

    const [expandedSections, setExpandedSections] = useState({
        courts: false,
        caseStatus: false,
        languages: false,
        judges: false,
        caseTypes: false
    });

    const [searchTerm, setSearchTerm] = useState('');

    const toggleSection = (section) => {
        setExpandedSections(prev => ({ ...prev, [section]: !prev[section] }));
    };

    const handleCheckboxChange = (category, item) => {
        setFilters(prev => ({
            ...prev,
            [category]: prev[category].includes(item)
                ? prev[category].filter(i => i !== item)
                : [...prev[category], item]
        }));
    };

    const handleYearChange = (e) => {
        setFilters(prev => ({ ...prev, year: parseInt(e.target.value) }));
    };

    const handleLanguageChange = (e) => {
        setFilters(prev => ({ ...prev, languages: e.target.value }));
        onLanguageChange(e.target.value);
    };

    const handleKeywordsChange = (e) => {
        setFilters(prev => ({ ...prev, keywords: e.target.value }));
    };

    const handleSearch = (category) => {
        console.log(`Searching for "${searchTerm}" in ${category}`);
    };

    const FilterSection = ({ title, category, items, isExpanded, onToggle }) => (
        <div className="mb-4">
            <button
                onClick={() => onToggle(category)}
                className="w-full flex justify-between items-center p-2 bg-gray-800 rounded hover:bg-gray-700 transition-colors duration-150"
            >
                <span className="text-sm font-semibold">{title}</span>
                <ChevronDown size={16} className={`transform transition-transform ${isExpanded ? 'rotate-180' : ''}`} />
            </button>
            {isExpanded && (
                <div className="mt-2 space-y-1 overflow-y-auto" style={{ maxHeight: '150px' }}>
                    <div className="flex items-center mb-2">
                        <input
                            type="text"
                            placeholder="Search..."
                            className="w-full px-2 py-1 text-xs bg-gray-700 text-white rounded"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <button
                            onClick={() => handleSearch(category)}
                            className="ml-1 p-1 bg-blue-600 text-white rounded hover:bg-blue-700"
                        >
                            <Search size={14} />
                        </button>
                    </div>
                    {items.map((item) => (
                        <div key={item} className="flex items-center justify-between hover:bg-gray-700 p-1 rounded">
                            <span className="text-xs">{item}</span>
                            <input
                                type="checkbox"
                                checked={filters[category].includes(item)}
                                onChange={() => handleCheckboxChange(category, item)}
                                className="form-checkbox h-3 w-3"
                            />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );

    return (
        <div className="p-4 bg-gray-900 text-white h-full overflow-y-auto">
            <img
                src={ministryOfLaw}
                alt="Ministry of Law"
                className="h-25 w-70 rounded-lg mb-3 mx-auto"
            />
            <h2 className="text-lg font-bold mb-4">Filters</h2>

            {/* Courts Filter */}
            <FilterSection
                title="Courts"
                category="courts"
                items={['Supreme Court', 'High Court', 'District Court', 'Commercial Court']}
                isExpanded={expandedSections.courts}
                onToggle={toggleSection}
            />

            {/* Case Status Filter */}
            <FilterSection
                title="Case Status"
                category="caseStatus"
                items={['Pending', 'Disposed', 'Ongoing', 'Closed']}
                isExpanded={expandedSections.caseStatus}
                onToggle={toggleSection}
            />

            {/* Language Selection */}
            <div className="mb-4">
                <label className="block text-sm font-semibold mb-2">Language</label>
                <select
                    value={filters.languages}
                    onChange={handleLanguageChange}
                    className="w-full p-2 bg-gray-800 text-white rounded"
                >
                    <option>English</option>
                    <option>Hindi</option>
                    <option>Marathi</option>
                    <option>Telugu</option>
                    <option>Tamil</option>
                    <option>Kannada</option>
                </select>
            </div>

            {/* Year Selection */}
            <div className="mb-4">
                <label className="block text-sm font-semibold mb-2">Year</label>
                <input
                    type="number"
                    value={filters.year}
                    onChange={handleYearChange}
                    className="w-full p-2 bg-gray-800 text-white rounded"
                    min="1950"
                    max={new Date().getFullYear()}
                />
            </div>

            {/* Judges Filter */}
            <FilterSection
                title="Judges"
                category="judges"
                items={['Justice A', 'Justice B', 'Justice C', 'Justice D']}
                isExpanded={expandedSections.judges}
                onToggle={toggleSection}
            />

            {/* Keywords */}
            <div className="mb-4">
                <label className="block text-sm font-semibold mb-2">Keywords</label>
                <input
                    type="text"
                    placeholder="Enter keywords"
                    value={filters.keywords}
                    onChange={handleKeywordsChange}
                    className="w-full p-2 bg-gray-800 text-white rounded"
                />
            </div>

            {/* Case Types Filter */}
            <FilterSection
                title="Case Types"
                category="caseTypes"
                items={['Civil', 'Criminal', 'Constitutional', 'Commercial']}
                isExpanded={expandedSections.caseTypes}
                onToggle={toggleSection}
            />
        </div>
    );
};

export default FilterBar;